import { mapMutations, mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinSync',
  props: {
    orgTwin: {
      type: Object,
      required: true
    },
    orgTwinStates: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      formValid: false,
      twinSearch: null,
      syncingTwins: [],
      syncMetaData: ['icon'],
      statesSync: {},
      errornousTwinId: -1
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    twinMetaItems() {
      return [{
        value: 'title',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle')
      }, {
        value: 'type',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.twinType')
      }, {
        value: 'icon',
        text: this.$i18n_t('Common.icon')
      }, {
        value: 'tags',
        text: this.$i18n_t('Common.tags')
      }, {
        value: 'polygonRadius',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.map.autoPolygonRadius')
      }, {
        value: 'floorDtwinId',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }];
    },
    stateMetaItems() {
      return [{
        value: 'title',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title')
      }, {
        value: 'unit',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit')
      }, {
        value: 'icon',
        text: this.$i18n_t('Common.icon')
      }, {
        value: 'visualization',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.panelTitle')
      }, {
        value: 'transformer',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.transformer')
      }];
    }
  },
  watch: {
    orgTwinStates() {
      if (this.orgTwinStates !== null) {
        this.loadStates();
      }
    }
  },
  mounted() {
    if (this.orgTwinStates !== null) {
      this.loadStates();
    }
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    get,
    loadStates() {
      this.statesSync = {};
      this.orgTwinStates.forEach(state => {
        this.statesSync[state.key] = [];
      });
      if (this.orgTwinStates.length) {
        this.statesSync[this.orgTwinStates[0].key] = ['icon'];
      }
    },
    syncingTwinSelected(e) {
      this.syncingTwins.push(e);
    },
    syncingTwinDeselected(e) {
      this.syncingTwins = this.syncingTwins.filter(t => t.id !== e.id);
      this.syncingTwins = cloneDeep(this.syncingTwins);
    },
    syncTwins() {
      ApiService.digitalTwinSync(this.orgTwin.id, {
        twinIds: this.syncingTwins.map(t => t.id),
        states: this.statesSync,
        metaData: this.syncMetaData
      }).then(res => {
        this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.copy.syncSuccessSnack'), 'success');
        this.$emit('close', res);
      }).catch(error => {
        console.error(error.response);
        this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.copy.syncFailedSnack'), 'error');
        if (get(error, 'response.status') === 403 && get(error, 'response.data.data.twinId')) {
          this.errornousTwinId = parseInt(get(error, 'response.data.data.twinId'));
          return;
        }
        if (get(error, 'response.status') === 404 && get(error, 'response.data.data.twinId')) {
          this.errornousTwinId = parseInt(get(error, 'response.data.data.twinId'));
          return;
        }
      });
    }
  }
};